import { render, staticRenderFns } from "./EG.vue?vue&type=template&id=71feb06a&"
import script from "./EG.vue?vue&type=script&lang=ts&"
export * from "./EG.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports